import { Expose, plainToClass, Transform, Type } from 'class-transformer';

import { BasicUser } from './basic-user-model';
import { Model } from './model';
import { formatMobileNumber } from 'src/app/shared/helper';
import { Category } from './category-model';

export class BaseTeacher extends Model {
  @Expose()
  @Transform(({ obj }) => plainToClass(BasicUser, obj, { strategy: 'excludeAll' }))
  user: BasicUser;

  @Expose()
  @Transform(({ value }) => (value ? formatMobileNumber(value) : null))
  phone: string;
  @Expose() address: string;
  @Expose() avatarUrl: string;
  @Expose() brief: string;
  @Expose() briefEn: string;
  @Expose() email: string;
  @Expose() certificate: string;
  @Expose() city: string;
  @Expose() country: string;
  @Expose()
  @Transform(({ value }) => (value && value !== '-' ? value.split(',&,') : []))
  ejaza: string[];
  @Expose() technicalExperience: string;
  @Expose() yearsOfExperience: string;
  @Expose()
  @Transform(({ value }) => (value ? value.split(',&,').join(',') : null))
  languages: string;
  @Expose()
  @Type(() => Category)
  categorize: Category[];
  @Expose() sessionPrice: string;
  @Expose() sessionLongPrice: string;
}
